import React from 'react'

import { Route, Redirect } from 'react-router-dom';
import Navigation from 'scripts/components/Navigation'
import MediaCampaign from './campaign'
import Media from './index';
import MediaDop from './declaration-of-performance';
import MediaHighResolution from './high-resolution';
import MediaManuals from './manuals';
import MediaSigns from './signs';
import MediaVideo from './video';

export default function download({ baseName, unauthenticated }) {
    return (
        <div
            className={`page-content page-content-${baseName}`}
        >

            <div className="main-container">
                <Route
                    path="/download"
                    render={() => <Redirect to="/download/media-signs" />}
                />

                <Route
                    path="/download/media-campaign"
                    render={(props) => <MediaCampaign {...props} market={'sv-SE'} />}
                />
                <Route
                    path="/download/media"
                    render={(props) => <Media {...props} market={'sv-SE'} />}
                />
                <Route
                    path="/download/media-dop"
                    render={(props) => <MediaDop {...props} market={'sv-SE'} />}
                />
                <Route
                    path="/download/media-high-resolution"
                    render={(props) => <MediaHighResolution {...props} market={'image-global'} />}
                />
                <Route
                    path="/download/media-manuals"
                    render={(props) => <MediaManuals {...props} market={'sv-SE'} />}
                />
                <Route
                    path="/download/media-signs"
                    render={(props) => <MediaSigns {...props} market={'global'} />}
                />
                <Route
                    path="/download/media-video"
                    render={(props) => <MediaVideo {...props} market={'sv-SE'} />}
                />




            </div>
            <Navigation baseName={baseName} unauthenticated={unauthenticated} />
        </div>
    )
}
